import { SET_LOV } from "../constants/actionTypes";

const lov = (state = {}, action) => {
  switch (action.type) {
    case SET_LOV:
      return {
        ...state,
        [action.index]: action.values
      };
    default:
      return state;
  }
};

export default lov;
